import { parsePhoneNumber } from 'libphonenumber-js';

export const formatPhoneNumber = (phoneNumber: string): string => {
  const formattedPhoneNumber =
    parsePhoneNumber(phoneNumber).formatInternational();

  const cleanedNumber = formattedPhoneNumber.replace(/\s+/g, '');
  return cleanedNumber;
};
